import Constants from '../actions/types';

const initialState = {
  stringComparators: [],
  error: null
};

const stringComparatorsReducer = (state = initialState, action) => {
  switch (action.type) {
    case Constants.STRINGCOMPARATORS_GET_SUCCESS: {
      const newState = {
        stringComparators: action.payload,
        error: null
      };

      return newState;
    }

    case Constants.STRINGCOMPARATORS_GET_FAILURE: {
      const newState = {
        stringComparators: [],
        error: action.payload
      };

      return newState;
    }

    default: {
      return state;
    }
  }
};

export default stringComparatorsReducer;
